import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
window.$ = window.jQuery = require("jquery");

export default {
    name: "EstadoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "EstadoPage",
            ss: ss,
            ajax: {
                "url": ss.indexEstado(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Estado', name: 'Estado', title: 'Estado' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                { data: 'Clase', name: 'Clase', title: 'Clase' },
                { data: 'Activo', name: 'Activo', title: 'Estado', render:function(data, type, row){
                    if (!row.Activo){
                        return '<i class="fa fa-ban text-danger"> Inactivo </i>'; 
                    }
                    else{
                        return '<i class="fa fa-check text-success"> Activo </i>'; 
                    }
                } 
                },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],

            clases: [],
            clase: {},

            estados: [],
            estado: {},
            errorBag: {}
        };
    },
    methods: {
        newEstado() {
            this.estado = {};
            this.estado.Activo = false;
            this.$refs['frm-estado'].show();
        },
        showEstado(id) {
            this.ss.showEstado(id).then(
                (result) => {
                    let response = result.data;
                    this.estado = response.data;
                    this.$refs['view-estado'].show();
                }
            ).catch(error => {
                console.log(error);
            });
        },
        editEstado() {
            this.$refs['frm-estado'].show();
            this.$refs['view-estado'].hide();
        },
        cancelEstado() {
            if (this.estado.id) {
                this.$refs['view-estado'].show();
            }
            this.$refs['frm-estado'].hide();
        },
        saveEstado() {
            this.ss.storeEstado(this.estado).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-estado'].hide();
                    this.$refs['datatable-estado'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteEstado() {
            this.$swal({
                title: "Estás seguro que deseas eliminar?",
                text: "Esta acción es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyEstado(this.estado)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-estado'].hide();
                                this.$refs['datatable-estado'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        getClase() {
            this.ss.listClase().then(
                (result) => {
                    let response = result.data;
                    this.clases = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        draw() {
            window.$('.btn-datatable-Estado').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showEstado(data);
            });
        }
    },
    components: {
        dataTable
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        }else{

            this.getClase();
        }
    }
};
